import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../../box';
import { ErrorState } from '../../error-state';
export const ErrorOverlay = (props) => {
    return (_jsx(FlexBox, { padding: 3, width: "100%", height: "100%", children: _jsx(ErrorState, { ...props }) }));
};
